import React, { useState } from 'react';
import './index.less';
import {Component} from 'react';
import $ from 'jquery';
import jQuery from 'jquery-easing';
import {withRouter} from 'react-router-dom'
import { BrowserRouter as Router, Route, Link} from 'react-router-dom'
import { checkPolicy } from '../../common/changeUrl'
import * as Request from '../../common/request';
import { upperLaundryTac } from '../../common/utils'
import { hideMask } from '../../component/cartMobile';
import { changeUrlMobile } from '../../common/changeUrl';

const pageText = {
    menu: ["ADHÉSION"],
    intro:  `
    <div class="text">Profitez d'activités et de soins personnalisés et uniques, de la beauté de la peau et de la mode à l'art, au théâtre et aux voyages.</div>
    <div class="text">L'adhésion à <span class="brand-name">NIHPLOD</span> se fait uniquement sur invitation.</div>
    <div class="text">Si vous souhaitez être invité à devenir membre de <span class="brand-name">NIHPLOD</span>, veuillez fournir les informations suivantes:</div>
    `,
    text: {
        MEMBERSHIP: 'ADHÉSION',
        SUBMIT: 'Nous Faire Parvenir',
        FULL_NAME: 'Nom Complet',
        EMAILADDRESS: 'Adresse E-mail',
        CONTACTNUM: 'Numéro De Contact',
        INVITATIONCODE: `Code d'Invitation`,
        BUTTON:"Nous Faire Parvenir",
        ERR_FULL_NAME: 'Le Nom Complet est requis.',
        ERR_EMAILADDRESS: 'Adresse E-mail est requis.',
        ERR_CONTACTNUM: 'Le Numéro De Contact est requis.',
        ERR_INVITATIONCODE: `Code d'Invitation non valide.`,
        ERR_EMAIL_FORMAT: "Format d'e-mail incorrect.",
        tipTxt: `Code d'invitation invalide`,
        SUCCESSTIP: `Soumis avec succès. <br />Nous vous contacterons bientôt.`
    },
    tips:`<p>Veuillez vous renseigner sur les politiques pertinentes du code d'invitation au salon de spa spécial partenaire ou à notre revendeur spécial.</p>`
}


const FormBody = (props) => {
    const [ name, setName ] = useState('');
    const [ email, setEmail ] = useState('');
    const [ contact, setContact ] = useState('');
    const [ invicode, setInvitation ] = useState('');
    
    const login7 = () => {
        const EMAIL_PATTERN = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
        $(".form-btn").addClass("disabled")
        if ($(".form-name").val() === ""){
            $(".blank-name").fadeIn(300,function () {
                setTimeout(
                function () {
                    $(".form-btn").removeClass("disabled");
                    $(".blank-name").fadeOut(300)
                },1000
                )
            });
        } else if ($(".form-email").val() === ""){
            $(".blank-email").fadeIn(300,function () {
            setTimeout(
                function () {
                    $(".form-btn").removeClass("disabled")
                    $(".blank-email").fadeOut(300)
                },1000
            )
            });
        } else if(!EMAIL_PATTERN.test(email)){
            $(".wrong-email").fadeIn(300,function () {
              setTimeout(
                function () {
                    $(".form-btn").removeClass("disabled")
                    $(".wrong-email").fadeOut(300)
                },1000
              )
            });
          } else if ($(".form-contact").val() === ""){
            $(".blank-contact").fadeIn(300,function () {
            setTimeout(
                function () {
                    $(".form-btn").removeClass("disabled")
                    $(".blank-contact").fadeOut(300)
                },1000
            )
            });
        }  else if ($(".form-invicode").val() === ""){
            $(".blank-invicode").fadeIn(300,function () {
            setTimeout(
                function () {
                    $(".form-btn").removeClass("disabled")
                    $(".blank-invicode").fadeOut(300)
                },1000
            )
            });
        } else {
            Request.post({
                url: '/u/reg',
                data: {
                    name,
                    email,
                    contact,
                    invicode,
                    type:1,
                }
            }).then(res => {
            $(".blank-acct").delay(1500).fadeIn(300,function () {
                setTimeout(
                    function () {
                        $(".form-btn").removeClass("disabled")
                        $(".blank-acct").fadeOut(300)
                    },3000
                )
            });
        });
      }
    };

    return (
        <div className='form-wrapper'>
            <div className='input-wrapper'>
                <input placeholder={pageText.text.FULL_NAME} onChange={e => {
                        setName(e.target.value);
                    }} className='form-name'></input>
                </div>
                <div className='input-wrapper'>
                    <input placeholder={pageText.text.EMAILADDRESS} onChange={e => {
                        setEmail(e.target.value);
                    }} className='form-email'></input>
                </div>
                <div className='input-wrapper'>
                    <input placeholder={pageText.text.CONTACTNUM} onChange={e => {
                        setContact(e.target.value);
                    }} className='form-contact'></input>
                </div>
                <div className='input-wrapper'>
                    <input placeholder={pageText.text.INVITATIONCODE} onChange={e => {
                        setInvitation(e.target.value);
                    }} className='form-invicode'></input>
                </div>
                <div className='tips' dangerouslySetInnerHTML={{ __html: upperLaundryTac(pageText.tips) }}></div>
            <div className='form-btn' onClick={() => login7()}>{pageText.text.SUBMIT}</div>
        </div>
    )
}


class PageModel extends Component {
    componentWillMount() {
        jQuery(".slideMask").animate({
            left: '-100vw'
          },1200,"easeInCubic",function(){
            $(".slideMask").css("left","100vw")
          })
          setTimeout(() => {
            window.scrollTo(0,0)
          }, 900);
    }
  
    componentDidMount(){
        $(".collection").removeClass('active')
        $(".exclusive").removeClass('active')
        $(".discover").removeClass('active')

        window.history.scrollRestoration = 'manual'
    }
  
    componentDidUpdate(prevProps, prevState, snapshot){
      hideMask()
    }
    
    
    render() {
        return (
            <div className="container tac forms">
                <div className='blank-input blank-name'>{pageText.text.ERR_FULL_NAME}</div>
                <div className='blank-input blank-email'>{pageText.text.ERR_EMAILADDRESS}</div>
                <div className='blank-input blank-contact'>{pageText.text.ERR_CONTACTNUM}</div>
                <div className='blank-input blank-invicode'>{pageText.text.ERR_INVITATIONCODE}</div>
                <div className='blank-input blank-acct'>{pageText.text.tipTxt}</div>
                <div className='blank-input wrong-email'>{pageText.text.ERR_EMAIL_FORMAT}</div>
                
                <div className='tac-menu'></div>
                <div className='tac-content'>
                    <div className='tac-content-section'>
                        <div className='tac-title'>{pageText.menu[0]}</div>
                        <div className='tac-context' dangerouslySetInnerHTML={{ __html: upperLaundryTac(pageText.intro) }}></div>
                    </div>
                    <FormBody></FormBody>
                </div>
            </div>
        );
    }
}
 
export default withRouter(PageModel);